import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow, MultiCombobox, Select } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useCompanyData } from '@/composables/useCompanyData';
    import { useRoleData } from '@/composables/useRoleData';
    import { computed, watch } from 'vue';
    import { Company, RoleGroup, RoleOption } from '@/types';
    import UserRoleComboBox from './UserRoleComboBox.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { companies, isPlaceholderDataCompanies } = useCompanyData(true);
    const { roleOptions, isPlaceholderDataRoleOptions } = useRoleData();

    const props = __props;

    const filteredCompanies = computed(() => {
        return companies.value.filter((company: Company) => {
            if (company.deleted_at === null) {
                return true;
            }

            return props.form.company_ids.includes(String(company.id));
        });
    });

    const selectedCompanies = computed(() => {
        return filteredCompanies.value.filter((company: Company) =>
            props.form.company_ids.includes(String(company.id)),
        );
    });

    const filteredRoles = computed(() => {
        return roleOptions.value.filter((group: RoleGroup) =>
            props.form.company_ids.includes(String(group.id)),
        );
    });

    watch(
        () => props.form.company_ids,
        (newCompanyIds, oldCompanyIds) => {
            if (oldCompanyIds) {
                props.form.contact_persons = props.form.contact_persons.filter(
                    (contactPersonId: string | number) =>
                        newCompanyIds.includes(String(contactPersonId)),
                );
                props.form.role_ids = props.form.role_ids.filter((role: RoleOption) =>
                    newCompanyIds.includes(String(role.company_id)),
                );
            }
        },
        { deep: true },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "users.form.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          placeholder: _ctx.$t('users.form.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "email",
      label: "users.form.email"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "email",
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
          placeholder: _ctx.$t('users.form.email'),
          type: "email"
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "phone",
      label: "users.form.phone"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "phone",
          modelValue: _ctx.form.phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
          placeholder: _ctx.$t('users.form.phone')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "company_ids",
      label: "users.form.company_ids"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.company_ids,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.company_ids) = $event)),
          options: filteredCompanies.value,
          placeholder: _ctx.$t('users.form.company_ids'),
          "label-by": "name",
          "value-by": "id",
          loading: _unref(isPlaceholderDataCompanies)
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "role_ids",
      label: "users.form.role_id"
    }, {
      default: _withCtx(() => [
        _createVNode(UserRoleComboBox, {
          modelValue: _ctx.form.role_ids,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.role_ids) = $event)),
          options: filteredRoles.value,
          grouped: "",
          placeholder: _ctx.$t('users.form.role_id'),
          loading: _unref(isPlaceholderDataRoleOptions)
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "contact_persons",
      label: "users.form.contact_persons"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.contact_persons,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.contact_persons) = $event)),
          options: selectedCompanies.value,
          placeholder: _ctx.$t('users.form.contact_persons'),
          "label-by": "name",
          "value-by": "id",
          loading: _unref(isPlaceholderDataCompanies)
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "language",
      label: "users.form.language"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.language,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.language) = $event)),
          translate: "",
          options: [
                    { value: 'da', label: 'users.language.da' },
                    { value: 'en', label: 'users.language.en' },
                ]
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})